

export class RandoEvent {
    
    /** PJ_UPDATE, CAM_UPDATE */
    public type:String;
    public data:Object;
    
    constructor() {
    }

    static build(type:String, data:Object) {
        let event = new RandoEvent();
        event.type=type;
        event.data=data;
        return event;
    }


}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/data/rando-event.ts